<div class="pt-4 d-flex bd-highlight">
  @for (item of toDisplay; track item; let i = $index) {
    <div class="lds-container p-2 flex-even bd-highlight" [ngClass]="i===0 ? '': 'ml-2'">
      <div class="name-title">
        {{item.name}}
      </div>
      <hr>
        <div class="mid-text">
          {{item.value}}
        </div>
        <div class="unit-text">
          {{item.unit}}
        </div>
      </div>
    }
  </div>